export const PRICING = {
  "one-way": { suv: 75, van: 110, luxury: 180 },
  "round-trip": { suv: 140, van: 200, luxury: 340 },
  "tour": { suv: 220, van: 320, luxury: 480 },
};

export const initialForm = {
  service_type: "one-way",
  vehicle_type: "suv",
  pickup_location: "Cancun International Airport (CUN)",
  dropoff_location: "",
  pickup_date: null,
  pickup_time: "12:00",
  return_date: null,
  return_time: "12:00",
  passengers: 2,
  luggage: 2,
  flight_number: "",
  airline: "",
  customer_name: "",
  customer_email: "",
  customer_phone: "",
  special_requests: "",
};

export const validateBooking = (form, lang) => {
  const es = lang === "es";
  if (!form.pickup_date) return es ? "Selecciona la fecha" : "Please pick a date";
  if (form.service_type === "round-trip" && !form.return_date) {
    return es ? "Selecciona la fecha de regreso" : "Please pick return date";
  }
  if (!form.customer_name || !form.customer_email || !form.customer_phone) {
    return es ? "Completa tus datos de contacto" : "Complete your contact info";
  }
  return null;
};
